import { useEffect } from 'react'
import { enum__ComponentType } from '../../common/Dictionaries';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../common/ObjectStructures/sKPI';
import { getBoardComponentInfoRecursiveValues } from '../../services/sKPI/board.service';
import { useDispatch } from 'react-redux';
import { action_setDefaultSelectedFiltersBinded, action_setExternalHome_Dataseries, action_setExternalHome_FireGetData } from '../../reducers/actions/SITE/externalHomeActions';
import { action_setBoardViewComponentInfoFull } from '../../reducers/actions/KPI/actions';
import { isNullUndefined } from '../../common/Helpers';


const useSearch = (defaultSelectedFiltersBinded, contextSite, selectedContract, inputParam_BoardId, boardComponentInfoRecursiveValues, htmlOnclick) => {  
    const dispatch = useDispatch();
      
    useEffect(()=> {
        const doIt = async () => {
            try {
                dispatch(action_setDefaultSelectedFiltersBinded(true))


                let filter = __OBJECT_STRUCTURE_BoardFilters("element");
                console.log(filter);
                filter.l_codes = [selectedContract.elementId.toString()];

                let serviceResponse = await getBoardComponentInfoRecursiveValues(
                    filter,
                    inputParam_BoardId,
                    enum__ComponentType.ELEMENT_KPI_LIST_BYROLE,
                    selectedContract.elementId.toString(),
                    null,
                    contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId, 
                    contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate, 
                    contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate,
                    contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId
                );

                if (serviceResponse.data.succeeded) {
                    const allDataseriesToCompare = serviceResponse.data.data[0].items;

                    //dispatch(action_setExternalHome_Dataseries(allDataseriesToCompare));
                    let componentTypeName = null
                    Object.keys(boardComponentInfoRecursiveValues).forEach(key => {
                        if (boardComponentInfoRecursiveValues[key] !== null) {
                            boardComponentInfoRecursiveValues[key].forEach(componentInfo => {
                                if (componentInfo.componentConfig.id.toString() === htmlOnclick){
                                    componentTypeName = key;
                                }
                            });
                        }
                    });

                    boardComponentInfoRecursiveValues[componentTypeName].forEach(componentInfo => {
                        if (componentInfo.componentConfig.id.toString() === htmlOnclick) {
                            if(!isNullUndefined(componentInfo.componentData)) {
                                componentInfo.componentData.items  = allDataseriesToCompare;
                            }
                            else {
                                componentInfo.componentData  = {items: allDataseriesToCompare };
                            }
                        }
                    })
                    dispatch(action_setBoardViewComponentInfoFull(boardComponentInfoRecursiveValues))

                    dispatch(action_setExternalHome_FireGetData(false))
                }
                else {
                    //dispatch(action_setExternalHome_Dataseries(null));
                    dispatch(action_setExternalHome_FireGetData(false))
                }
            }
            catch (error) {
                //dispatch(action_setExternalHome_Dataseries(null));
                dispatch(action_setExternalHome_FireGetData(false))
            }
        }
        
        if (defaultSelectedFiltersBinded === false) {
            doIt()
        }
    }, [defaultSelectedFiltersBinded, selectedContract, inputParam_BoardId, boardComponentInfoRecursiveValues, htmlOnclick]);
}

export {
    useSearch
}